import { FEATURE_UNIQ_KEY } from '../../constants';

export const buildMetadataKey = (storageName: string) => {
    return `${FEATURE_UNIQ_KEY}:${storageName}`;
};
